// import React from 'react'
// import { FaLocationPin } from 'react-icons/fa6'
// import { Link } from 'react-router-dom'
// import { jobLocations } from '../../pages/Homepage/data'

// const SearchByLocation = ({data}) => {
//   // console.log('data -->', data)
//   return (
//     <div>
//         <h1 className="text-4xl font-extrabold text-center uppercase mb-6 text-gray-900">
//     Job By Location
//   </h1>
//   <p className="text-center text-gray-700 mb-10 max-w-2xl mx-auto">
//     We provide you with jobs even at the proximity of your location and place of choice and convenience.
//   </p>
//   <ul className="flex flex-wrap justify-center gap-8">
//     {jobLocations.map((item, index) => (
//       <li className="px-5 py-3 border-2 w-[250px]" key={index}>
//       <div className="p-2 w-fit border-2 border-slate-300 rounded-full text-orange-500 text-xl">
//         <FaLocationPin/>
//       </div>
//       <Link
//         className="text-lg capitalize text-gray-800 hover:text-indigo-600 font-medium transition-colors"
//         to={`/jobs/?state=${item}`}
//         >
//         {item}
//       </Link>
//       <div className="text-sm text-gray-500">vacancy {data[item]?.length}</div>
//     </li>
//     ))}
//   </ul>
//     </div>
//   )
// }

// export default SearchByLocation





import React, { useState, useEffect } from 'react';
import { FaLocationPin } from 'react-icons/fa6';
import { Link } from 'react-router-dom';
import { statesAndLgas } from '../../stateAndLga';

const SearchByLocation = () => {
  const [stateJobs, setStateJobs] = useState({});
  const [selectedState, setSelectedState] = useState('');
  const [selectedLGA, setSelectedLGA] = useState('');
  const [filteredJobs, setFilteredJobs] = useState({});

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}job/alljob2?page=1&limit=100`);
        const data = await response.json();
        if (Array.isArray(data)) {
          const groupedByState = data.reduce((acc, job) => {
            const state = job.state.toLowerCase();
            acc[state] = acc[state] || [];
            acc[state].push(job);
            return acc;
          }, {});
          setStateJobs(groupedByState);
          setFilteredJobs(groupedByState); // Initialize filtered jobs with all data
        }
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    };
    fetchJobs();
  }, []);

  const handleStateChange = (e) => {
    const state = e.target.value.toLowerCase();
    setSelectedState(state);
    setSelectedLGA(''); // Reset LGA when state changes
    if (!state) {
      setFilteredJobs(stateJobs);
    } else {
      const filtered = { [state]: stateJobs[state] || [] };
      if (selectedLGA) {
        filtered[state] = (stateJobs[state] || []).filter(job =>
          job.localGovernment.toLowerCase() === selectedLGA.toLowerCase()
        );
      }
      setFilteredJobs(filtered);
    }
  };

  const handleLGAChange = (e) => {
    const lga = e.target.value.toLowerCase();
    setSelectedLGA(lga);
    if (selectedState && lga) {
      const filtered = {
        [selectedState]: (stateJobs[selectedState] || []).filter(job =>
          job.localGovernment.toLowerCase() === lga
        )
      };
      setFilteredJobs(filtered);
    } else if (!lga && selectedState) {
      setFilteredJobs({ [selectedState]: stateJobs[selectedState] || [] });
    }
  };

  return (
    <div>
      <h1 className="text-4xl font-extrabold text-center uppercase mb-6 text-gray-900">
        Job By Location
      </h1>
      <p className="text-center text-gray-700 mb-10 max-w-2xl mx-auto">
        We provide you with jobs even at the proximity of your location and place of choice and convenience.
      </p>
      <div className="mb-4 text-center flex flex-col sm:flex-row justify-center items-center gap-2">
        <select
          value={selectedState}
          onChange={handleStateChange}
          className="p-2 border border-gray-300 rounded-md w-full sm:w-auto"
        >
          <option value="">Select State</option>
          {Object.keys(statesAndLgas).map(state => (
            <option key={state} value={state.toLowerCase()}>{state}</option>
          ))}
        </select>
        <select
          value={selectedLGA}
          onChange={handleLGAChange}
          className="p-2 border border-gray-300 rounded-md w-full sm:w-auto"
          disabled={!selectedState}
        >
          <option value="">Select LGA (optional)</option>
          {selectedState && statesAndLgas[selectedState.toUpperCase()]?.map(lga => (
            <option key={lga} value={lga.toLowerCase()}>{lga}</option>
          ))}
        </select>
      </div>
      <ul className="flex flex-wrap justify-center gap-2 sm:gap-8">
        {Object.keys(filteredJobs).map((state, index) => (
          <li className="px-5 py-3 border-2 w-40 sm:w-[250px]" key={index}>
            <div className="p-2 w-fit border-2 border-slate-300 rounded-full text-green-500 text-xl">
              <FaLocationPin />
            </div>
            <Link
              className="text-lg capitalize text-gray-800 hover:text-indigo-600 font-medium transition-colors"
              to={`/jobs/?state=${state}`}
            >
              {state}
            </Link>
            <div className="text-sm text-gray-500">vacancy {filteredJobs[state]?.length || 0}</div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SearchByLocation;